import { Group, Image, Rect, Text } from '@antv/g6-react-node';
import React from 'react';
export const NodeGroup = (props) => React.createElement(Group, Object.assign({}, props));
export const NodeRect = (props) => React.createElement(Rect, Object.assign({}, props));
export const NodeText = (props) => React.createElement(Text, Object.assign({}, props, { style: props.style }));
export const NodeImage = (props) => React.createElement(Image, Object.assign({}, props));
